export default {
  note: {
    title: 'Notas especiais:',
    description: 'Tentaremos acomodar os pedidos, mas não podemos fazer alterações que afetem o preço.',
    placeholder: 'Adicionar pedido especial',
  },
  buttons: {
    add: '+ Adicionar artigo',
    update_item: 'Atualizar',
    add_to_card: 'Adicionar ao carrinho',
  },
  alcohol_warning: 'Este artigo tem restrição de idade.',
  caffeine_warning:
    'Teor elevado de cafeína. Não recomendado para crianças ou mulheres grávidas ou a amamentar.{{value}}',
  error_messages: {
    product_unavailable: 'Esgotado!',
    item_not_added: 'Não foi possível adicionar o artigo. Tente novamente.',
  },
  success_messages: {
    item_added: 'Artigo adicionado com sucesso',
  },
};
